import { render, staticRenderFns } from "./thirdAccountRecordLists.vue?vue&type=template&id=2461f2e2&scoped=true&"
import script from "./thirdAccountRecordLists.vue?vue&type=script&lang=js&"
export * from "./thirdAccountRecordLists.vue?vue&type=script&lang=js&"
import style0 from "./thirdAccountRecordLists.vue?vue&type=style&index=0&id=2461f2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461f2e2",
  null
  
)

export default component.exports